import { StyledSelect } from 'modules/template-editor/ui/components/elements/components/events-selector/styles';
import styled from '@emotion/styled';
import overrideSelectComponents from '../../../../../ud-form/components/select/component/override';
import { css } from '@emotion/react';
import classNames from 'classnames';

export const Control = styled(StyledSelect)`
  background-color: white;
  border: 1px solid #ebebeb;
`;

export const components = {
  ...overrideSelectComponents,
  Control: (props: any) => {
    const isOpen = props.selectProps.menuIsOpen;

    return (
      <Control
        {...props.innerProps}
        css={css`
          border: ${isOpen ? '1px solid #D9B244' : '1px solid #EBEBEB'};
          max-width: 370px;

          &:hover {
            border: 1px solid #d9b244;
          }
        `}
        className={classNames('d-flex flex-row pl-4', {
          disabled: props.isDisabled,
          focused: props.isFocused,
          multi: props.isMulti,
          opened: props.menuIsOpen,
        })}
      >
        {props.children}
      </Control>
    );
  },
};
